import classNames from 'clsx';
import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';

import { useStickyTopHeaderClassName } from '@swf/cms';
import { getDisplayName } from '@swf/core/utils';

const withWidgetTestId = <P extends object>(
  Component: React.ComponentType<P>,
  testId: string,
  options: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> = {},
  Element: 'div' | 'nav' = 'div',
  classNameHookVariant?: 'header' | 'sports' | 'casino'
): React.FC<P> => {
  const WithWidgetTestId: React.FC<P> = (props) => {
    const { styles: stickyTopHeaderClassName } = useStickyTopHeaderClassName(classNameHookVariant);
    return (
      <Element
        {...options}
        className={classNames(options.className, stickyTopHeaderClassName)}
        data-testid={`${testId}-widget`}
      >
        <Component {...props} />
      </Element>
    );
  };

  // Ensures StarsWidget can access static properties
  WithWidgetTestId.displayName = `WithResolver(${getDisplayName(
    Component as React.ComponentType
  )})`;
  hoistNonReactStatics(WithWidgetTestId, Component);

  return WithWidgetTestId;
};

export default withWidgetTestId;
